module.exports = __webpack_public_path__ + "img/cart.d651cfce.svg";